import Moment from 'moment'
import { criteria, type } from '../components/project-information/tab-content/tab-revenue-planning/constants.js'
import { REACT_APP_IS_ACTUAL_REVENUE_ALLOCATION_EDITABLE } from '../lib/utils/envConstants.js'
// import { totalDiffMonths } from './date.js'
import { sumBy, /* sumByIf */ percentage, subtract, divide, /* divideValue, divideFlooring, */ period, multiply, add, isNumberEqual, isNumber, formatNumber } from './math.js'

const { COMPLETION, PERIOD, DELIVERY, INSTALLATION, MD } = criteria
const { SERVICE, OTHER_SERVICE, LICENSE, LICENSE_MA, SUBSCRIPTION, HARDWARE, HARDWARE_MA, CR } = type

const isActualRevenueAllocationEditable = REACT_APP_IS_ACTUAL_REVENUE_ALLOCATION_EDITABLE

const isSubmittedProjectProfit = (ppsLatestSubmittedDate) => {
  return !!ppsLatestSubmittedDate && !isActualRevenueAllocationEditable
}

// const getTotalAllocationMonth = (start_date, end_date, submitPPSDate) => {
//   // subtract range of actual allocation
//   const isSubmittedPPS = isSubmittedProjectProfit(submitPPSDate)
//   const isSubmitPPSAfterStartDate = Moment(submitPPSDate).isSameOrAfter(Moment(start_date), 'month')
//   const startDate = isSubmitPPSAfterStartDate ? Moment(submitPPSDate).add(1, 'month') : Moment(start_date)
//   const endDate = Moment(end_date)
//   // if didn't submit pps use start_date and end_date of LOB
//   const totalMonth = isSubmittedPPS  ? totalDiffMonths(startDate, endDate) : totalDiffMonths(start_date, end_date)
//   return totalMonth
// }

const getStarDateLobMonth = (start_date, submitPPSDate) => {
  const isSubmittedPPS = isSubmittedProjectProfit(submitPPSDate)
  const isSubmitPPSAfterStartDate = Moment(submitPPSDate).isAfter(Moment(start_date))
  const startDateOrPPSDate = isSubmitPPSAfterStartDate ? Moment(submitPPSDate).add(1, 'month').startOf('month') : Moment(start_date)
  // if empty pps submitted return project_start_date
  return isSubmittedPPS ? Moment(startDateOrPPSDate).format('YYYY-MM-DD') : Moment(start_date).format('YYYY-MM-DD')
}

// const getRemainingRevenue = (lob_months, lob_revenue) => {
//   const actualRevenue = lob_months.reduce((result, l) => {
//     return l.isEditable ? result : add(result, l.revenue)
//   }, '0.00')
//   const remainingRevenue = subtract(lob_revenue, actualRevenue)
//   return remainingRevenue
// }

// const getRemainingRatio = (lob_months) => {
//   const actualRatio = lob_months.reduce((result, l) => {
//     return l.isEditable ? result : add(result, l.ratio)
//   }, '0.00')
//   const remainingRatio = subtract(100, actualRatio)
//   return remainingRatio
// }

const getRemainingManDay = (lob_months, startDate, endDate) => {
  const remainingManDay = lob_months.reduce((result, l) => {
    const { month } = l
    const isBetween = Moment(month).isBetween(startDate, endDate, 'month', '[]')
    return isBetween ? add(result, l.ratio) : result
  }, '0.00')
  return remainingManDay
}

// for period criteria
const getRemainingMonth = (lob_months, startDate, endDate) => {
  const remainingMonth = lob_months.reduce((result, l) => {
    const { month, isEditable } = l
    const isBetween = Moment(month).isBetween(startDate, endDate, 'month', '[]')
    return isBetween && isEditable ? add(result, 1) : result
  }, '0.00')
  return remainingMonth
}

const getRemainingMonthManDay = (lob_months, startDate, endDate) => {
  const remainingMonth = lob_months.reduce((result, l) => {
    const { month, isEditable, ratio } = l
    const isBetween = Moment(month).isBetween(startDate, endDate, 'month', '[]')
    const isRatioNotEqualZero = !isNumberEqual(ratio, 0)
    return isBetween && isEditable && isRatioNotEqualZero ? add(result, 1) : result
  }, '0.00')
  return remainingMonth
}

// for period criteria
const getActualRatio = (lob_months) => {
  const actualRatio = lob_months.reduce((result, l) => {
    return l.isEditable ? result : add(result, l.ratio)
  }, '0.00')
  return actualRatio
}

const getActualRevenue = (lob_months) => {
  const actualRevenue = lob_months.reduce((result, l) => {
    return l.isEditable ? result : add(result, l.revenue)
  }, '0.00')
  return actualRevenue
}

// for period criteria
const getActualManDay = (lob_months, startDate, endDate) => {
  const actualManDay = lob_months.reduce((result, l) => {
    const { month } = l
    const isBetweenStartAndEndMonth = Moment(month).isBetween(startDate, endDate, 'month', '[]')
    const startDateInMonth = Moment(month).isSame(Moment(startDate), 'month') ? Moment(startDate) : Moment(month).startOf('month')
    const endDateInMonth = Moment(month).isSame(Moment(endDate), 'month') ? Moment(endDate) : Moment(month).endOf('month')
    const daysInMonth = Moment(endDateInMonth).diff(Moment(startDateInMonth), 'days') + 1
    return !l.isEditable && isBetweenStartAndEndMonth ? add(result, daysInMonth) : result
  }, '0.00')
  return actualManDay
}

// obsolete version
// const completionCriteria = (lobAllocation, ppsLatestSubmittedDate) => {
//   const { lob_months, lob_revenue, start_date, end_date } = lobAllocation
//   const isSubmittedPPS = isSubmittedProjectProfit(ppsLatestSubmittedDate)
//   // const remainingRevenue = isSubmittedPPS ? getRemainingRevenue(lob_months, lob_revenue) : lob_revenue
//   const remainingRatio = isSubmittedPPS ? getRemainingRatio(lob_months) : 100
//   const actualAllocatedRevenue = sumByIf(lob_months, 'revenue', l => !l.isEditable )
//   const actualAllocatedRatio = sumByIf(lob_months, 'ratio', l => !l.isEditable )
//   const startDate = getStarDateLobMonth(start_date, ppsLatestSubmittedDate)
//   const endDate = Moment(end_date)
//   const totalMonth = getTotalAllocationMonth(startDate, endDate, ppsLatestSubmittedDate)
//   const lobMonth = lob_months.reduce((result, l) => {
//     let revenue = formatNumber(0)
//     let ratio = formatNumber(0)
//     const { isEditable, month } = l
//     // ignore un-editable month (actual by pps)
//     if (!isEditable) return result.concat(l)
//     // fallback 0.00(zero) when lob_revenue equal 0.00
//     if (isNumber(lob_revenue).equal(0)) return result.concat({...l, ratio, revenue })
//     const isLastMonth = Moment(month).isSame(endDate, 'month')
//     const isBetweenStartAndEndMonth = Moment(month).isBetween(startDate, endDate, 'month', '[]')
//     if (isLastMonth) {
//       // sum actual revenue and subtract with total
//       const sumActualRatio = sumBy(result, 'ratio')
//       const sumActualRevenue = sumBy(result, 'revenue')
//       ratio = subtract(100, sumActualRatio)
//       revenue = subtract(lob_revenue, sumActualRevenue)
//     }
//     else if (isBetweenStartAndEndMonth) {
//       const pseudoRevenue = percentage(lob_revenue, actualAllocatedRatio)
//       const shouldEqualizeRevenue = subtract(pseudoRevenue, actualAllocatedRevenue)
//       const revenueEqualize = divideValue(shouldEqualizeRevenue, totalMonth)
//       ratio = divideFlooring(remainingRatio, totalMonth)
//       const nonEqualizeRevenue = percentage(lob_revenue, ratio)
//       revenue = add(nonEqualizeRevenue, revenueEqualize)
//     }
//     return result.concat({...l, ratio, revenue })
//   }, [])
//   lobAllocation.lob_months = lobMonth
//   return lobAllocation
// }

const completionCriteria = (lobAllocation, inputType) => {
  const { lob_months, lob_revenue, start_date, end_date } = lobAllocation
  const startDate = Moment(start_date)
  const endDate = Moment(end_date)
  const lastMonth = lob_months.reduce((r, l) => {
    const hasInput = !isNumberEqual(l.ratio, 0) || !isNumberEqual(l.revenue, 0)
    const isAfterNonZeroRatio = Moment(l.month).isAfter(Moment(r), 'month') && hasInput
    return isAfterNonZeroRatio ? l.month : r
  }, lob_months[0].month)
  const lobMonth = lob_months.reduce((result, l) => {
    const { month, isEditable } = l
    let { revenue = formatNumber(0), ratio = formatNumber(0) } = l
    // ignore un-editable month (actual by pps)
    if (!isEditable) return result.concat(l)
    const isBetweenStartAndEndMonth = Moment(month).isBetween(startDate, endDate, 'month', '[]')
    const isLastMonth = Moment(month).isSame(Moment(lastMonth), 'month')
    if (isBetweenStartAndEndMonth && !isNumber(lob_revenue).equal(0)) {
      if (inputType === 'revenue') {
        ratio = period(revenue, lob_revenue)
        // lastMonth case
        if (isLastMonth) {
          const sumRatio = sumBy(result, 'ratio')
          const sumRatioAndThisMonth = add(sumRatio, ratio)
          const shouldBe100 = isNumber(sumRatioAndThisMonth).greaterThan(100)
          if (shouldBe100) {
            const diffDecimalRatio = subtract(100, sumRatioAndThisMonth)
            ratio = add(ratio, diffDecimalRatio)
          }
        }
      } else if (inputType === 'ratio') {
        revenue = percentage(lob_revenue, ratio)
      } else {
        revenue = percentage(lob_revenue, ratio)
      }
    } else {
      ratio = formatNumber(0)
      revenue = formatNumber(0)
    }
    return result.concat({ ...l, ratio, revenue })
  }, [])
  lobAllocation.lob_months = lobMonth
  return lobAllocation
}

const periodCriteria = (lobAllocation, ppsLatestSubmittedDate) => {
  const { lob_months, lob_revenue, start_date, end_date } = lobAllocation
  const isSubmittedPPS = isSubmittedProjectProfit(ppsLatestSubmittedDate)
  const startDate = getStarDateLobMonth(start_date, ppsLatestSubmittedDate)
  const endDate = Moment(end_date)
  const actualRatio = getActualRatio(lob_months)
  const actualManDay = getActualManDay(lob_months, startDate, endDate)
  const remainingMonth = getRemainingMonth(lob_months, startDate, endDate)
  const lobMonth = lob_months.reduce((result, l) => {
    const { isEditable, month } = l
    let revenue = formatNumber(0)
    let ratio = formatNumber(0)
    // ignore un-editable month (actual by pps)
    if (!isEditable) return result.concat(l)
    // fallback 0.00(zero) when lob_revenue equal 0.00
    if (isNumber(lob_revenue).equal(0)) return result.concat({...l, ratio, revenue })
    const isLastMonth = Moment(month).isSame(endDate, 'month')
    const isBetweenStartAndEndMonth = Moment(month).isBetween(startDate, endDate, 'month', '[]')
    if (isLastMonth) {
      // sum actual revenue and subtract with total
      const sumMonthPeriod = sumBy(result, 'ratio')
      const sumMonthRevenue = sumBy(result, 'revenue')
      ratio = subtract(100, sumMonthPeriod)
      revenue = subtract(lob_revenue, sumMonthRevenue)
    } else if (isBetweenStartAndEndMonth) {
      const startDateInMonth = Moment(month).isSame(Moment(startDate), 'month') ? Moment(startDate) : Moment(month).startOf('month')
      const endDateInMonth = Moment(month).isSame(Moment(endDate), 'month') ? Moment(endDate) : Moment(month).endOf('month')
      const daysInProject = Moment(endDate).diff(Moment(startDate), 'days') + 1
      const daysInMonth = Moment(endDateInMonth).diff(Moment(startDateInMonth), 'days') + 1
      if (!isSubmittedPPS) {
        ratio = period(daysInMonth, daysInProject)
        revenue = percentage(lob_revenue, ratio)
      } else {
        const submittedRatio = period(actualManDay, daysInProject)
        const diffRatio = subtract(submittedRatio, actualRatio)
        const diffRatioEachMonth = divide(diffRatio, remainingMonth)
        const normalRatio = period(daysInMonth, daysInProject)
        const proRateRatio = add(normalRatio, diffRatioEachMonth)
        ratio = proRateRatio
        revenue = percentage(lob_revenue, ratio)
      }
    }
    return result.concat({...l, ratio, revenue })
  }, [])
  lobAllocation.lob_months = lobMonth
  return lobAllocation
}

const deliveryOrInstallationCriteria = (lobAllocation, parentAllocation, inputType) => {
  const { lob_months, start_date, end_date } = lobAllocation
  const { revenue: parentRevenue } = parentAllocation
  const startDate = Moment(start_date)
  const endDate = Moment(end_date)
  const lastMonth = lob_months.reduce((r, l) => {
    const hasInput = !isNumberEqual(l.ratio, 0) || !isNumberEqual(l.revenue, 0)
    const isAfterNonZeroRatio = Moment(l.month).isAfter(Moment(r), 'month') && hasInput
    return isAfterNonZeroRatio ? l.month : r
  }, lob_months[0].month)
  const lobMonth = lob_months.reduce((result, l) => {
    const { month, isEditable } = l
    let { revenue = formatNumber(0), ratio = formatNumber(0) } = l
    // ignore un-editable month (actual by pps)
    if (!isEditable) return result.concat(l)
    const isBetweenStartAndEndMonth = Moment(month).isBetween(startDate, endDate, 'month', '[]')
    const isLastMonth = Moment(month).isSame(Moment(lastMonth), 'month')
    if (isBetweenStartAndEndMonth) {
      if (inputType === 'revenue') {
        ratio = period(revenue, parentRevenue)
        // lastMonth case
        if (isLastMonth) {
          const sumRatio = sumBy(result, 'ratio')
          const sumRatioAndThisMonth = add(sumRatio, ratio)
          const shouldBe100 = isNumber(sumRatioAndThisMonth).greaterThan(100)
          if (shouldBe100) {
            const diffDecimalRatio = subtract(100, sumRatioAndThisMonth)
            ratio = add(ratio, diffDecimalRatio)
          }
        }
      } else if (inputType === 'ratio') {
        revenue = percentage(parentRevenue, ratio)
      }
    } else {
      ratio = formatNumber(0)
      revenue = formatNumber(0)
    }
    return result.concat({ ...l, ratio, revenue })
  }, [])
  const sumRevenue = sumBy(lobMonth, 'revenue')
  lobAllocation.lob_months = lobMonth
  lobAllocation.lob_revenue = sumRevenue
  return lobAllocation
}

const manDayCriteria = (lobAllocation, ppsLatestSubmittedDate) => {
  const { lob_months, lob_revenue, start_date, end_date } = lobAllocation
  const isSubmittedPPS = isSubmittedProjectProfit(ppsLatestSubmittedDate)
  const startDate = Moment(start_date)
  const endDate = Moment(end_date)
  const sumManDay = getRemainingManDay(lob_months, startDate, endDate)
  const actualRevenue = getActualRevenue(lob_months)
  const actualRatio = getActualRatio(lob_months)
  const remainingMonth = getRemainingMonthManDay(lob_months, startDate, endDate)
  const lastMonth = lob_months.reduce((r, l) => {
    const isAfterNonZeroRatio = Moment(l.month).isAfter(Moment(r), 'month') && !isNumberEqual(l.ratio, 0)
    return isAfterNonZeroRatio ? l.month : r
  }, lob_months[0].month)
  const lobMonth = lob_months.reduce((result, l) => {
    const { month, isEditable } = l
    let { revenue = formatNumber(0), ratio = formatNumber(0) } = l
    // ignore un-editable month (actual by pps)
    if (!isEditable) return result.concat(l)
    const isBetweenStartAndEndMonth = Moment(month).isBetween(startDate, endDate, 'month', '[]')
    const isLastMonth = Moment(month).isSame(Moment(lastMonth), 'month')
    if (isBetweenStartAndEndMonth) {
      if (!isSubmittedPPS) {
        const revenueEachMonth = multiply(ratio, lob_revenue)
        revenue = divide(revenueEachMonth, sumManDay)

        if (isLastMonth) {
          const sumRevenue = sumBy(result, 'revenue')
          const sumRevenueAndThisMonth = add(sumRevenue, revenue)
          const diffDecimalRevenue = subtract(lob_revenue, sumRevenueAndThisMonth)
          revenue = add(revenue, diffDecimalRevenue)
        }
      } else {
        const revenueMulManDay = multiply(ratio, lob_revenue)
        const revenueEachMonth = divide(revenueMulManDay, sumManDay)
        const revenueMulActualManDay = multiply(actualRatio, lob_revenue)
        const revenueEachMonthFromActualManDay = divide(revenueMulActualManDay, sumManDay)
        const diffRatio = subtract(revenueEachMonthFromActualManDay, actualRevenue)
        const proRateDiffRatioEachMonth = divide(diffRatio, remainingMonth)
        const isRatioNotEqualZero = !isNumberEqual(ratio, 0)
        revenue = isRatioNotEqualZero ? add(revenueEachMonth, proRateDiffRatioEachMonth) : revenue

        if (isLastMonth) {
          const sumRevenue = sumBy(result, 'revenue')
          const sumRevenueAndThisMonth = add(sumRevenue, revenue)
          const diffDecimalRevenue = subtract(lob_revenue, sumRevenueAndThisMonth)
          revenue = add(revenue, diffDecimalRevenue)
        }
      }
    } else {
      ratio = formatNumber(0)
      revenue = formatNumber(0)
    }
    return result.concat({ ...l, ratio, revenue })
  }, [])
  lobAllocation.lob_months = lobMonth
  return lobAllocation
}

export const updateLobMonth = (lobAllocation, parentAllocation, ppsLatestSubmittedDate, inputType) => {
  // inputTyp e.g. revenue, ratio
  const { criteria } = lobAllocation
  const { type } = parentAllocation
  switch (criteria) {
    case COMPLETION:
      if (![SERVICE, OTHER_SERVICE, CR].includes(type)) return lobAllocation
      return completionCriteria(lobAllocation, inputType)
    case PERIOD:
      if (![SERVICE, OTHER_SERVICE, HARDWARE_MA, LICENSE_MA, SUBSCRIPTION, CR].includes(type)) return lobAllocation
      return periodCriteria(lobAllocation, ppsLatestSubmittedDate)
    case DELIVERY:
      if (![SERVICE, OTHER_SERVICE, HARDWARE, LICENSE, HARDWARE_MA, LICENSE_MA, SUBSCRIPTION, CR].includes(type)) return lobAllocation
      return deliveryOrInstallationCriteria(lobAllocation, parentAllocation, inputType)
    case INSTALLATION:
      if (![HARDWARE, LICENSE, CR].includes(type)) return lobAllocation
      return deliveryOrInstallationCriteria(lobAllocation, parentAllocation, inputType)
    case MD:
      if (![SERVICE, OTHER_SERVICE, CR].includes(type)) return lobAllocation
      return manDayCriteria(lobAllocation, ppsLatestSubmittedDate)
    default:
      return lobAllocation
  }
}

export const reCalRevenueAllocation = (allocation, project) => {
  const { start_date, end_date } = project
  const sumRevenueProject = sumBy(allocation, 'revenue')
  const reCalRevenueAllocation = allocation.map(a => {
    const { lobs, revenue } = a
    const monthList = getMonthList(start_date, end_date)
    const _sumTypeAllocationMonths = monthList.map(m => {
      const monthRevenue = lobs.reduce((r, l) => {
        const foundRevenue = l.lob_months.find(lm => lm.month === m) || ''
        return add(foundRevenue && foundRevenue.revenue, r)
      }, '0.00')
      return { month: m, revenue: formatNumber(monthRevenue)}
    })
    const _sumTotalTypeRev = sumBy(_sumTypeAllocationMonths, 'revenue')
    a._sumTypePercent = period(revenue, sumRevenueProject)
    a._sumTotalTypeRev = _sumTotalTypeRev
    a._sumTypeAllocationMonths = _sumTypeAllocationMonths
    // sub-lob
    lobs.map(l => {
      const { lob_months, lob_revenue } = l
      const _sumLobTotalRatio = sumBy(lob_months, 'ratio')
      const _sumLobTotalRevenue = sumBy(lob_months, 'revenue')
      const lobPercent = period(lob_revenue, revenue)
      l.lob_percent = lobPercent
      l._sumLobTotalRatio = _sumLobTotalRatio
      l._sumLobTotalRevenue = _sumLobTotalRevenue
      return l
    })
    return a
  })
  reCalRevenueAllocation._sumProjectRevenue = sumRevenueProject
  reCalRevenueAllocation._sumAllocationRevenue = sumBy(reCalRevenueAllocation, '_sumTotalTypeRev')
  return reCalRevenueAllocation
}

export const getAllocationDateChange = (allocation) => {
  const { start_date, end_date, lob_months } = allocation
  const newLobMonth = lob_months.map(l => {
    const isNotInDateRange = !Moment(l.month).isBetween(Moment(start_date), Moment(end_date), 'month', '[]')
    const formatZero = formatNumber(0)
    return isNotInDateRange ? { ...l, ratio: formatZero, revenue: formatZero } : l
  })
  const newAllocation = { ...allocation, lob_months: newLobMonth }
  return newAllocation
}

export const getMonthList = (start_date, end_date) => {
  let startDate = Moment(start_date).startOf('month')
  const endDate = Moment(end_date).endOf('month')
  const monthList = []
  while (startDate.isBefore(endDate)) {
    monthList.push(startDate.format('YYYY-MM'))
    startDate = startDate.add(1, 'month')
  }
  return monthList
}



// WEBPACK FOOTER //
// ./src/function/revenue-allocation.js